export let bonusQuestions = [
    "102. Won a free sex toy from Great Sex Day?",
    "103. Kept a lobster in the bathtub of your residence?",
    "104. Invited your RA to a group sex event you were hosting?",
    "105. Rode a Starship robot to completion?",
    "106. Fountain, squat, bare ass, agape?",
    "107. Used the fountain as your alarm clock?",
    "108. Had sex in your roommates bed?",
    "109. Had sex with a WPI professor, faculty or staff member?",
]